<template>
  <div>
    <Card style="margin-bottom: 100px">
      <p slot="title" style="text-align: left">
        <Icon type="other" size="15"></Icon>
        <Icon type="md-apps" />
        {{$t('tableName')}}
      </p>
      <a href="#" slot="extra" @click.prevent="getCaseList">
        <Icon type="md-refresh" />
        {{$t('refresh')}}
      </a>
      <a href="#" slot="extra" @click.prevent="exportToExcel">
        <Icon type="ios-redo" />
        导出Excel
      </a>
      <Table
        border
        :columns="columns"
        :data="caseList"
        ref="table"
        @on-select="handleSelect"
        @on-select-all="handleSelectAll"
        @on-select-all-cancel='onSelectAllCancel'
        @on-select-cancel='onSelectCancel'
      >
        <template slot-scope="{ row }" slot="blsczt">
          <span v-if="row.blsczt !== '病例上传完成' && row.blsczt !== '检测完成'" style="color: #0057ff">
            {{row.blsczt}}
          </span>
          <span v-else-if="row.blsczt === '检测完成'">
            <span @dblclick="onUpdateState(row.caseId)">{{row.blsczt}}</span>
             <Tooltip content="查看报告" placement="bottom" transfer>
                <Icon type="ios-document" style="cursor:pointer;color: #11ba48" @click="onShowReport(row.reportPdfUrl)"/>
             </Tooltip>
          </span>
          <span v-else="" style="cursor:pointer" @click="onGetReport(row.caseId)">
            {{row.blsczt}}
            <Tooltip content="获取病例状态" placement="bottom" transfer>
                <Icon type="md-refresh" />
            </Tooltip>
          </span>
        </template>
        <template slot-scope="{ row }" slot="number">
          <span>{{row.number}}</span>
          <Tooltip content="小程序样本" placement="bottom" transfer>
            <Icon v-if="row.orderId" type="md-cloudy" />
          </Tooltip>
        </template>
        <template slot-scope="{ row }" slot="button">
          <!-- Delete Button -->
          <Button type="error" size="small" @click="delCaseDetail(row.caseId)">
            {{ $t('deleteButton') }}
          </Button>

          <!-- Edit Button -->
          <Button type="primary" size="small" style="margin-left: 8px;" @click="getCaseDetail(row.caseId)">
            {{ $t('editButton') }}
          </Button>

          <!-- Conditional Dropdown -->
          <Dropdown v-if="status" transfer>
            <Button type="success" size="small" style="margin-left: 8px;">
              {{ $t('diagnosisButton') }}
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem>
                <Button type="info" size="small" @click="getDataScreening(row.layerUrl)">
                  {{ $t('caseList.dataFilteringButton') }}
                </Button>
              </DropdownItem>
              <DropdownItem>
                <Button type="info" size="small" @click="editDiagnosticResults(row.caseId, row.layerUrl)">
                  {{ $t('caseList.diagnosticResultButton') }}
                </Button>
              </DropdownItem>
              <DropdownItem>
                <Button type="info" size="small" @click="getDiagnosisInfo(row.caseId, '1')">
                  {{ $t('caseList.viewReportButton') }}
                </Button>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <!-- Barcode Printing Button -->
          <Button type="info" size="small" style="margin-left: 8px;" @click="printCaseQrCode(row.caseId)">
            {{ $t('barcodePrintingButton') }}
          </Button>
          <Dropdown v-if="row.def1" transfer>
            <Button :type="row.def2 === 1 ? (!row.def3 ? 'warning' : '') : 'success'" size="small" style="margin-left: 8px;">
              检验
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem>
                <Button type="info" size="small" @click="getApplicationForm(row.caseId)" :disabled="row.def2 === 1">
                  上传申请单
                </Button>
              </DropdownItem>
              <DropdownItem>
                <Button type="warning" size="small" @click="getNoDowReport(row.caseId)">
                  获取报告单
                </Button>
              </DropdownItem>
              <DropdownItem>
                <Button size="small" @click="getShowReport(row.def3)" :disabled="!row.def3">
                  查看报告单
                </Button>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
      <Row>
        <Col span="12">
          <div style="text-align: left; margin-top: 10px;min-height: 42px">
            <Button v-if="selectedCaseList.length > 0" type="info" size="large" :loading="loadingPrintStatus"  @click="printTip()">{{ loadingPrintStatus ? this.$t('caseImport.printing') : '批量打印' }}</Button>
          </div>
        </Col>
        <Col span="12">
          <Page class-name="page"
                :total="total"
                :page-size="pageSize"
                transfer
                show-sizer
                show-total
                show-elevator
                ransfer="transfer"
                @on-change="pageNumChange"
                @on-page-size-change="onPageSizeChange"></Page>
        </Col>
      </Row>
    </Card>
    <!-- 编辑病例弹窗 -->
    <div v-if="showCaseEdit">
      <Modal v-model="showCaseEdit" width="1400" @on-cancel="getCaseList" :mask-closable="false">
        <CaseDetail :caseId="editCaseId" style="margin-top: 10px"></CaseDetail>
        <div slot="footer"></div>
      </Modal>
    </div>
    <!-- 诊断报告弹出框 -->
    <div v-if="isShowDiagnosis">
      <Modal v-model="isShowDiagnosis"
             width="1240"
             @on-cancel="getCaseList"
             :footer-hide= "true"
             :closable="false"
             :mask-closable="false"
             :styles="{top: '20px'}">
        <CaseDiagnosisInfo :caseId="editCaseId" :showOnly="showOnly"  @getIsShowDiagnosis="getIsShowDiagnosis" style="margin-top: 10px"></CaseDiagnosisInfo>
      </Modal>
    </div>
    <!--编辑诊断结果模态框-->
    <div v-if="isEditDiagnosticResults" >
      <Modal v-model="isEditDiagnosticResults"
             :title="$t('caseList.editDiagnosisResults')"
             width="800"
             :footer-hide= "true"
             :mask-closable="false"
             class-name="vertical-center-modal">
        <edit-diagnostic-results @openDiagnosticReport="openDiagnosticReport"  @getIsEditDiagnosticResults="getIsEditDiagnosticResults" :caseId="editCaseId" :layerUrl="editLayerUrl"></edit-diagnostic-results>
      </Modal>
    </div>
    <div v-if="isShowReport" >
      <Modal v-model="isShowReport"
             width="800"
             :footer-hide= "true"
             :mask-closable="true"
             :styles="{top: '20px', 'padding-bottom': '150px'}"
       >
        <report :previewUrls="reportPdfUrl"/>
      </Modal>
    </div>
    <Modal
      v-model="isUpdateSataShow"
      title="提示"
      @on-ok="updateState"
      @on-cancel="isUpdateSataShow = false">
      <p>是否重新获取报告</p>
    </Modal>
    <Spin size="large" fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>获取检测状态...</div>
    </Spin>
  </div>
</template>

<script>
import SlideTable from './SlideTable'
import CaseDetail from '../../case/caseManager/caseDetail/CaseDetail'
import CaseDiagnosisInfo from '../diagnosis/CaseDiagnosisInfo'
import EditDiagnosticResults from '../diagnosis/EditDiagnosticResults'
import Report from '../../base/report/Report'
import {formatDate} from '../../../utils/date'
export default {
  name: 'CaseTable',
  components: { SlideTable, CaseDetail, CaseDiagnosisInfo, EditDiagnosticResults, Report },
  props: {
    searchMap: {
      type: Map,
      default: null
    }
  },
  data () {
    return {
      $vue: '',
      loadingPrintStatus: false, // 打印状态
      selectedCaseList: [], // 已选病例
      status: true,
      showOnly: '0',
      patName: '',
      pathology: '',
      caseStatus: '0',
      inDateStart: formatDate(new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 30 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss'),
      inDateEnd: formatDate(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 2 * 60 * 60 * 1000 - 1), 'yyyy-MM-dd hh:mm:ss'),
      pageSize: 10,
      pageNum: 1,
      total: 10,
      transfer: true,
      isShowDiagnosis: false, // 是否显示报告
      isEditDiagnosticResults: false, // 是否显示编辑诊断结果模态框
      caseList: [],
      editCaseId: '',
      editLayerUrl: '',
      showCaseEdit: false,
      userName: '',
      spinShow: false,
      isShowReport: false,
      reportPdfUrl: '',
      caseId: '',
      isUpdateSataShow: false
    }
  },
  computed: {
    columns () {
      return [
        {
          type: 'selection',
          width: 54,
          align: 'center'
        },
        {
          width: 40,
          type: 'expand',
          render: (h, params) => {
            return h(SlideTable, {
              props: {
                caseId: params.row.caseId
              }
            })
          }
        },
        {
          title: this.$t('caseList.serialNumber'),
          width: 65,
          align: 'center',
          type: 'index'
        },

        {
          title: this.$t('caseList.name'),
          width: 100,
          align: 'center',
          key: 'name'
        },
        {
          title: this.$t('caseList.gender'),
          width: 65,
          align: 'center',
          key: 'sex',
          render: (h, row) => {
            let sex = row.row.sex
            if (sex) {
              return h('span', this.$t('caseList.menAndWomen.male'))
            } else {
              return h('span', this.$t('caseList.menAndWomen.female'))
            }
          }
        },
        {
          title: this.$t('caseList.age'),
          width: 65,
          align: 'center',
          key: 'age'
        },
        {
          title: this.$t('caseList.uploadStatus'),
          width: 140,
          sortable: true,
          align: 'center',
          slot: 'blsczt'
        },
        // {
        //   title: this.$t('caseList.fast'),
        //   width: 65,
        //   align: 'center',
        //   key: 'quick',
        //   render: (h, row) => {
        //     let value = row.row.quick
        //     if (value === 1) {
        //       return h('span', [
        //         this.$t('caseList.isFast.yes')
        //       ])
        //     } else {
        //       return h('span', [
        //         this.$t('caseList.isFast.no')
        //       ])
        //     }
        //   }
        // },
        {
          title: this.$t('caseList.caseType'),
          align: 'center',
          minWidth: 110,
          key: 'bllx'
        },
        {
          title: this.$t('caseList.sentToHospital'),
          align: 'center',
          key: 'hospital_name',
          minWidth: 100
        },
        {
          title: this.$t('caseList.number'),
          slot: 'number',
          width: 150
        },
        {
          title: this.$t('caseList.createDt'),
          key: 'createDt',
          align: 'center',
          width: 150
        },
        // {
        //   title: this.$t('caseList.sample'),
        //   width: 120,
        //   key: 'sample',
        //   render: (h, row) => {
        //     /* 溢出不换行 */
        //     return h('span', {
        //       style: {
        //         'position': 'relative',
        //         'white-space': 'nowrap',
        //         'overflow': 'hidden',
        //         'text-overflow': 'ellipsis'
        //       }
        //     }, row.row.sample)
        //   }
        // },
        {
          title: this.$t('caseList.operating'),
          width: 240,
          align: 'center',
          slot: 'button'
        }
      ]
    }
  },
  beforeMount () {
    this.$vue = this
    this.userName = localStorage.getItem('userName')
    this.getCaseList()
  },
  methods: {
    // 处理单个选择
    handleSelect (selection, row) {
      const index = this.selectedCaseList.findIndex(
        item => item.caseId === row.caseId
      )
      if (index === -1) {
        this.selectedCaseList.push({
          caseId: row.caseId,
          pathologyId: row.number
        })
      } else {
        this.selectedCaseList.splice(index, 1)
      }
    },
    // 处理全选当前页
    handleSelectAll (selection) {
      if (selection.length === 0) {
        // 取消全选当前页
        const currentPageIds = this.caseList.map(row => row.caseId)
        this.selectedCaseList = this.selectedCaseList.filter(
          item => !currentPageIds.includes(item.caseId)
        )
      } else {
        // 全选当前页（去重处理）
        selection.forEach(row => {
          const exist = this.selectedCaseList.some(
            item => item.caseId === row.caseId
          )
          if (!exist) {
            this.selectedCaseList.push({
              caseId: row.caseId,
              pathologyId: row.number
            })
          }
        })
      }
    },
    // 取消全选 触发
    onSelectAllCancel () {
      this.selectedCaseList = this.selectedCaseList.filter(item => {
        return this.caseList.every(el => {
          return item.caseId !== el.caseId
        })
      })
      console.log(this.selectedCaseList)
    },
    // 取消选中 时触发
    onSelectCancel (selection, row) {
      let result = this.selectedCaseList.findIndex((el) => {
        return el.caseId === row.caseId
      })
      this.selectedCaseList.splice(result, 1)
    },
    // 批量打印提示
    printTip () {
      this.$Modal.confirm({
        title: this.$t('caseImport.printTipConfirmTitle'),
        content: '<p style="color: red">' + '将进行打印当前已选择的病例二维码！' + '</p>',
        okText: this.$t('caseImport.printTipConfirmOkText'),
        cancelText: this.$t('caseImport.printTipConfirmCancelText'),
        onOk: () => { this.print() }
      })
    },
    // 打印二维码
    async print () {
      if (!this.loadingPrintStatus) {
        this.loadingPrintStatus = true
        // 将选中的selectedCaseList,按照里面的参数pathologyId升序排序
        this.selectedCaseList = this.selectedCaseList.sort((a, b) => {
          const numA = parseInt(a.pathologyId.replace(/\D/g, ''), 10)
          const numB = parseInt(b.pathologyId.replace(/\D/g, ''), 10)
          return numA - numB
        }).map(item => item.caseId)
        console.log(this.selectedCaseList)
        for (let i = 0; i < this.selectedCaseList.length; i++) {
          console.log(this.selectedCaseList[i])
          // 执行打印二维码动作. 延迟执行
          await new Promise(resolve => {
            setTimeout(async () => {
              await this.printCaseQrCode(this.selectedCaseList[i])
              resolve()
            }, 300) // 每个间隔1秒
          })
        }
        this.loadingPrintStatus = false
        this.selectedCaseList = []
        this.$refs.table.selectAll(false)
        this.$Notice.success({
          title: this.$t('caseImport.printTipSucessTitle'),
          desc: this.$t('caseImport.printTipSucessDesc')
        })
      } else {
        this.$Notice.warning({
          title: this.$t('caseImport.printTipWarningTitle'),
          desc: this.$t('caseImport.printTipWarningDesc')
        })
      }
    },
    rowClassName (row, index) {
      if (row.blsczt !== '病例上传完成') {
        return 'demo-table-info-row'
      }
    },
    // 关闭编辑模态框，显示诊断报告模态框
    openDiagnosticReport (showOnly) {
      this.isEditDiagnosticResults = false
      this.isShowDiagnosis = true
      this.showOnly = showOnly
    },
    // 取消保存诊断结果，关闭编辑模态框
    getIsEditDiagnosticResults (showOnly) {
      this.isEditDiagnosticResults = false
      this.showOnly = showOnly
      this.getCaseList()
    },
    // 关闭报告弹出框
    getIsShowDiagnosis (isShowDiagnosis) {
      this.isShowDiagnosis = isShowDiagnosis
      this.getCaseList()
    },
    // 编辑诊断结果
    editDiagnosticResults (caseId, layerUrl) {
      this.editCaseId = caseId
      this.editLayerUrl = layerUrl
      if (layerUrl !== null && layerUrl !== undefined && layerUrl !== '') {
        this.isEditDiagnosticResults = true
      } else {
        this.$Notice.warning({
          title: this.$t('caseList.messageNotification'),
          desc: this.$t('caseList.editDiagnosisResultPrompt')
        })
      }
    },
    // 查看报告
    getDiagnosisInfo (caseId, showOnly) {
      this.editCaseId = caseId
      this.isShowDiagnosis = true
      this.showOnly = showOnly
    },
    // 筛选数据
    getDataScreening (layerUrl) {
      if (layerUrl !== null && layerUrl !== undefined && layerUrl !== '') {
        window.HandleEvent('openFilePath', layerUrl)
      } else {
        this.$Notice.warning({
          title: this.$t('caseList.messageNotification'),
          desc: this.$t('caseList.filterDataTips')
        })
      }
    },
    // 导出Excel
    exportToExcel () {
      this.$refs.table.exportCsv({
        filename: '病例统计',
        original: false,
        columns: [
          {
            title: '序号',
            key: 'index'
          },
          {
            title: '日期',
            key: 'sendDate'
          },
          {
            title: '编号',
            key: 'number'
          },
          {
            title: '姓名',
            key: 'name'
          },
          {
            title: '性别',
            key: 'sex'
          },
          {
            title: '年龄',
            key: 'age'
          },
          {
            title: '手机号',
            key: 'phone'
          },
          {
            title: '身份证号',
            key: 'patNo'
          },
          {
            title: '送检医院',
            key: 'hospital_name'
          },
          {
            title: '风险等级',
            key: 'levelCom'
          },
          {
            title: '细胞学诊断结果',
            key: 'diagnoseResult'
          },
          {
            title: '临床处理意见',
            key: 'recommendation'
          }
        ],
        data: this.caseList.filter((data, index) => {
          data.index = index + 1
          data.sex = data.sex ? '男' : '女'
          data.patNo = '\'' + data.patNo
          if (data.levelCom) {
            data.levelCom = data.levelCom + '级'
          } else {
            data.levelCom = ''
          }
          return data
        })
      })
    },
    // 获取病例列表
    async getCaseList () {
      let params = new URLSearchParams()
      params.append('pageSize', this.pageSize.toString())
      params.append('pageNum', this.pageNum.toString())
      // 添加查询条件
      if (this.patName !== undefined && this.patName !== '') {
        params.append('patName', this.patName)
      }
      if (this.pathology !== undefined && this.pathology !== '') {
        params.append('pathology', this.pathology)
      }
      if (this.caseStatus !== undefined && this.caseStatus !== '') {
        params.append('caseStatus', this.caseStatus)
      }
      if (this.inDateStart !== undefined && this.inDateStart !== '') {
        params.append('inDateStart', this.inDateStart)
      }
      if (this.inDateEnd !== undefined && this.inDateEnd !== '') {
        params.append('inDateEnd', this.inDateEnd)
      }
      params.append('laboratoryId', localStorage.getItem('laboratoryId'))
      params.append('userId', localStorage.getItem('userId' + this.userName))
      let suc = await this.$http.post(this.$vue.getData('GET_CASE_LIST_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.total = data.pageInfo.total
        this.caseList = data.pageInfo.list
        this.status = data.status === '1'

        // 数据更新后恢复选中状态
        this.$nextTick(() => {
          this.caseList.forEach(row => {
            const isSelected = this.selectedCaseList.some(
              item => item.caseId === row.caseId
            )
            if (isSelected) {
              this.$set(row, '_checked', true)
            }
          })
        })
      }
    },
    // 计算病例的状态（采用病例表中上传状态字段，此方法废弃）
    // computedStatus (h, row) {
    //   if (row.row.states === undefined) {
    //     return h('span', '没有记录')
    //   }
    //   // 将状态分割为数组，判断是否包含未上传
    //   let collection = row.row.states.split(',')
    //   let noUpload = collection.indexOf('0')
    //   if (noUpload !== -1) {
    //     return h('span', '待扫描')
    //   }
    //   let hasScan = collection.indexOf('5')
    //   if (hasScan !== -1) {
    //     return h('span', '已扫描')
    //   }
    //   let hasScanWaitUpload = collection.indexOf('10')
    //   if (hasScanWaitUpload !== -1) {
    //     return h('span', '已扫描待上传')
    //   }
    //   let uploading = collection.indexOf('15')
    //   if (uploading !== -1) {
    //     return h('span', '上传中')
    //   }
    //   let uploadSuc = collection.indexOf('20')
    //   if (uploadSuc !== -1) {
    //     return h('span', '上传成功')
    //   }
    // },
    // 页码改变时，回调方法
    pageNumChange (pageNum) {
      this.pageNum = pageNum
      // 重新获取列表
      this.getCaseList()
    },
    // 每页条数改变时回调方法
    onPageSizeChange (pageSize) {
      this.pageSize = pageSize
      // 重新获取列表
      this.getCaseList()
    },
    // 搜索方法
    search (map) {
      this.patName = map.get('patName')
      this.pathology = map.get('pathology')
      this.inDateStart = map.get('inDateStart')
      this.inDateEnd = map.get('inDateEnd')
      this.caseStatus = map.get('caseStatus')
      // 调用获取病例列表方法
      this.getCaseList()
    },
    // 打印病例二维码
    async printCaseQrCode (caseId) {
      let params = new URLSearchParams()
      params.append('caseId', caseId)
      params.append('userInfoId', localStorage.getItem('userId' + localStorage.getItem('userName')))
      let suc = await this.$http.post(this.$vue.getData('PRINT_SLIDE_QRCODE_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        let IsMoreSlides = data.length > 1 ? 'true' : 'false'
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let code = ''
          if (IsMoreSlides) {
            code = item.slide_code
          } else {
            code = item.pathology_id
          }
          let qrcode = '@' + item.slide_id
          try {
            window.HandleEvent('print', code, qrcode)
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
        }
      }
      console.log(suc)
    },
    // 查询病例详情信息
    getCaseDetail (caseId) {
      this.editCaseId = caseId
      this.showCaseEdit = true
      //  this.$router.push({path: '/detail/' + caseId})
    },
    // 删除病例信息
    async removeCase (caseId) {
      let params = new URLSearchParams()
      params.append('caseId', caseId)
      let suc = await this.$http.post(this.$vue.getData('DEL_CASE_DETAIL'), params)
      let result
      if (suc.data.result === '1') {
        result = this.$t('caseList.deleteResultPrompt.success')
        this.getCaseList()
      } else {
        result = this.$t('caseList.deleteResultPrompt.failed')
      }
      this.$Notice.success({
        title: this.$t('caseList.deleteResultPrompt.title'),
        desc: result
      })
    },
    // 查询病例详情信息
    delCaseDetail (caseId) {
      this.$Modal.confirm({
        title: this.$t('caseList.deletePrompt.title'),
        content: '<p>' + this.$t('caseList.deletePrompt.content') + '！</p>',
        onOk: () => {
          this.removeCase(caseId)
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel')
        }
      })
    },
    // 刷新获取报告
    async onGetReport (caseId) {
      this.spinShow = true
      let params = new URLSearchParams()
      params.append('caseId', caseId)
      let suc = await this.$http.post(this.$vue.getData('GET_REPORTSTATE_URL'), params)
      if (suc.data.result === '1') {
        this.getCaseList()
        this.spinShow = false
      } else {
        this.spinShow = false
      }
    },
    onShowReport (reportPdfUrl) {
      this.reportPdfUrl = reportPdfUrl
      this.isShowReport = true
    },
    onUpdateState (caseId) {
      this.isUpdateSataShow = true
      this.caseId = caseId
    },
    async updateState () {
      let params = new URLSearchParams()
      params.append('caseId', this.caseId)
      await this.$http.post(this.$vue.getData('UPDATE_CASE_STATE_URL'), params)
      this.getCaseList()
    },
    // 提交申请单
    async getApplicationForm (caseId) {
      let params = new URLSearchParams()
      params.append('case_id', caseId)
      let suc = await this.$http.post(this.$vue.getData('GET_APPLICATIONFORM_URL'), params)
      if (suc.data.result === '1') {
        this.$Notice.success({
          title: '消息提醒',
          desc: suc.data.data
        })
      } else {
        this.$Notice.error({
          title: '消息提醒',
          desc: suc.data.data
        })
      }
      this.getCaseList()
    },
    // 获取检测报告
    async getNoDowReport (caseId) {
      let params = new URLSearchParams()
      params.append('case_id', caseId)
      let suc = await this.$http.post(this.$vue.getData('GET_NODOWREPORT_URL'), params)
      if (suc.data.result === '1') {
        this.$Notice.success({
          title: '消息提醒',
          desc: suc.data.data
        })
      } else {
        this.$Notice.error({
          title: '消息提醒',
          desc: suc.data.data
        })
      }
      this.getCaseList()
    },
    async getShowReport (def3) {
      let data = JSON.parse(def3)
      const result = data.map(item => `${item.hospitalRptItemName}：${item.resultString}`).join('</br>')
      this.$Modal.info({
        title: '检测结果',
        content: result
      })
    }
  },
  watch: {
    searchMap: 'search'
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .page
    margin-top 10px
    text-align right
  .over-width
    position relative
    white-space nowrap /* 溢出不换行 */
    overflow hidden
    text-overflow ellipsis
</style >
<style lang="stylus" rel="stylesheet/stylus">
  .ivu-table td.demo-table-info-column
    background-color: #2db7f5
    color: #fff
  .vertical-center-modal
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal
      top: 0
</style>



// WEBPACK FOOTER //
// src/components/base/table/CaseTable.vue